import EventEmitter from "./utils/EventEmitter";
import FontFaceObserver from 'fontfaceobserver'
import MediaInterventionBloc from "./MediaInterventionBloc";

export default class TaxonomyPage extends EventEmitter {
    constructor(element) {
        super();

        this.el = element;

        this.tabsButtons = this.el.querySelectorAll('.tabs-buttons-container .tab-button');
        this.tabsContents = this.el.querySelectorAll('[data-content-type]');
        this.globalFlux = document.querySelector('.paragraph.global-flux');
        this.supportBlock = document.querySelector('.paragraph--type--soutien');
        this.mediaInterventionBloc = document.querySelector('.media-intervention-pushes-bloc')



        const font = new FontFaceObserver('Sora')

        font.load().then(() => {
            this.setTabHeight()

            if (this.mediaInterventionBloc) {
                const mediabloc = new MediaInterventionBloc(this.mediaInterventionBloc)
                // listen to event to update height of tabs
                mediabloc.on('itemsReordered', () => {
                    this.setTabHeight()
                })
            }

            this.events()

            const c =this.el.querySelector('.comma-separator')

            // Find all a tags in the comma separator
            const aTags = Array.from(c.querySelectorAll('a'))
            // add a comma in the end of each a tag
            aTags.forEach((aTag, index) => {
                if (index !== aTags.length - 1) {
                    aTag.insertAdjacentHTML('afterend', ',')
                }
            })
        })

        // on resize, update page height
        window.addEventListener('resize', () => {
            this.updatePageHeight()
        })
    }

    setTabHeight() {
        this.tabsContents.forEach((content) => {
            content.style.maxHeight = `${content.scrollHeight}px`;

            if (content.classList.contains('force-closed')) {
                content.style.maxHeight = 0;
                content.style.opacity = 0;
                content.style.position = 'absolute';
                content.style.left = "-9999px";
            }
        })
    }

    events() {
        this.tabsButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                if (button.classList.contains('active'))
                    return

                this.tabsButtons.forEach((tabButton) => {
                    tabButton.classList.remove('active')
                })
                button.classList.add('active')

                // Scroll to top el
                const scrollToEl = document.querySelector('.tabs-buttons-container');
                window.scrollTo({
                    top: scrollToEl.getBoundingClientRect().top + window.scrollY - 25,
                    behavior: "smooth"
                })

                this.updateTabs(e.currentTarget.dataset.type);
            })
        })

        // On resize we update tabs height
        window.addEventListener('resize', () => {
            this.setTabHeight()
        })
    }

    updateTabs(title) {

        // If title is egal to "all" we show all tabs contents
        if (title === 'all') {
            this.tabsContents.forEach((content) => {
                content.classList.add('active');
                content.style.opacity = 1;
                content.style.position = 'relative';
                content.style.left = "0px";
                content.style.maxHeight = `${content.scrollHeight}px`;

                if (content.classList.contains('force-closed')) {
                    content.style.maxHeight = 0;
                    content.style.opacity = 0;
                    content.style.position = 'absolute';
                    content.style.left = "-9999px";
                }
            })
            return;
        }

        // All tabs that are not the one we want to show are set to height 0 and opacity 0
        this.tabsContents.forEach((content) => {
            if (content.dataset.contentType !== title) {
                // set to opacity 0 and height 0
                content.style.opacity = 0;
                content.style.maxHeight = 0;
                content.style.position = 'absolute';
                content.style.left = "-9999px";
                content.classList.remove('active');
            } else {
                // set to opacity 1 and height auto
                console.log('test');
                content.classList.add('active');
                content.style.opacity = 1;
                content.style.position = 'relative';
                content.style.left = "0px";
                // Get content height
                const contentHeight = content.scrollHeight;
                content.style.maxHeight = contentHeight + 'px';
            }
        })
    }

    updatePageHeight() {
        const pageHeight = this.el.scrollHeight;
        this.el.style.minHeight = pageHeight + 'px';
    }

    insertSupportBlock() {
        return new Promise((resolve) => {
            const viewContents = this.globalFlux.querySelectorAll('.view-content');

            viewContents.forEach((viewContent) => {
                const viewContentChildren = Array.from(viewContent.children)
                const middleIndex = Math.floor(viewContentChildren.length / 2)
                const middleChild = viewContentChildren[middleIndex]
                const supportBlockClone = this.supportBlock.cloneNode(true);
                viewContent.insertBefore(supportBlockClone, middleChild)
            })

            setTimeout(() => {
                resolve()
            },250)
        })
    }

}
